import { render, staticRenderFns } from "./BulkItem.vue?vue&type=template&id=813cca26&scoped=true"
import script from "./BulkItem.vue?vue&type=script&lang=js"
export * from "./BulkItem.vue?vue&type=script&lang=js"
import style0 from "./BulkItem.vue?vue&type=style&index=0&id=813cca26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813cca26",
  null
  
)

export default component.exports